import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { MODAL_QUERY_NM } from './modal';
import { authExpired, getLocalStorage,  } from './auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const contextPath = '/project';
const queryName = 'PROJECT';

export const useGetTargetProjectByPid = (param) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_TARGET`], 
                () => param ? getProjects(param, '/', authInfo && authInfo.accessToken) : {},
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

export const useGetTargetProjectByPno = (param) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_TARGET`], 
                () => param ? getProjects(param, '/pno/', authInfo && authInfo.accessToken) : {},
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

export const useGetProjects = (param) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}`], 
                () => getProjects(param, '/', authInfo && authInfo.accessToken),
                {
                    refetchInterval:300000,
                    onSuccess:()=>queryClient.setQueryData(['REFRESH_TIME'],{time:new Date()}),
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

const getProjects = async (param,subUrl,accessToken) => {

    const pid = param ? subUrl+`${param}` : '';
    const url = contextPath+pid;

    const retVal = await instance.get(url, {headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        // let retVal = [];
                                        // if(res.data){
                                        //     const fTemp = res.data.map((item,index)=>{
                                        //         const surveyInfoTemp = JSON.parse(item.survey_info);
                                        //         // let pdInfo = null;
                                        //         // if(pdTemp && pdTemp[0].dno > 0){
                                        //         //     const pdPtItem = pdTemp.map((pdItem)=>{
                                        //         //         const ptTemp = JSON.parse(pdItem.pt_info);
                                        //         //         return ptTemp && ptTemp[0].seq> 0 ? {...pdItem,pt_info:ptTemp} : {...pdItem,pt_info:null}
                                        //         //     })
                                        //         //     pdInfo = pdPtItem;
                                        //         // }
                                        //         return {
                                        //             ...item,
                                        //             id:index,
                                        //             survey_info: surveyInfoTemp
                                        //     }})
                                        //     retVal = fTemp;
                                        // }
                                        // return retVal;
                                        return res.data;
                                    })

    return retVal;

}

export const useGetProjectCodeList = () => {
    const queryClient = useQueryClient();
    return useQuery(
                [`${queryName}_CODE_LIST`], 
                () => getProjectCodeList(),
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

const getProjectCodeList = async () => {
    const url = contextPath+'/utils/getProjectCodeList';

    const retVal = await instance.get(url, null)
                                    .then((res)=>{
                                        return res.data;
                                    })

    return retVal;
}

export const useSetProject = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                case 'PUT':
                    return putProject(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DELETE':
                    return deleteProject(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putProject(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}`], { refetchInactive: true })
                queryClient.invalidateQueries([`${queryName}_TARGET`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const putProject = async (param, accessToken) => {

    const sendParam = {
        pid: param.pid,
        oid: param.oid,
        rid: param.rid,
        cid: param.cid,
        pnm: param.pnm,
        reg_cd: param.reg_cd,
        pro_tp: param.pro_tp,
        pro_kd: param.pro_kd,
        pro_st: param.pro_st,
        sdate: param.sdate,
        edate: param.edate,
        odate: param.odate,
        outputs: param.outputs,
        descr: param.descr,
        file_req: param.file_req,
        file_doc: param.file_doc,
        file_car: param.file_car,
        file_etc: param.file_etc,
    }

    const retVal = await instance.post(contextPath, sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteProject = async (param, accessToken) => {
    const retVal = await instance.delete(contextPath+'/'+param.pid,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

export const useSetProjectStatus = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => putProjectStatus(sendParam, authInfo ? authInfo.accessToken:''),
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const putProjectStatus = async (param, accessToken) => {
    const url = contextPath+'/statusUpdate/'+param.pid;
    const retVal = await instance.put(url, param, {headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res.data;
                                    })

    return retVal;
}